import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingState = () => {
  return (
    <div className="loading-state flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="loading-spinner animate-spin mb-4">
        <Icon name="Loader2" size={48} color="var(--color-primary)" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2">
        Loading Menu
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center">
        Preparing delicious dishes for you...
      </p>
    </div>
  );
};

export default LoadingState;